import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import AddMemberScreen from '@/js/screens/Supplier/AddMemberScreen';
export default function AddMemberModal({
  selectedPart,
  open,
  onClose,
  onSubmit,
  state,
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="max-w-[50%] max-h-[95%] overflow-y-auto "
        style={{ position: 'fixed', zIndex: 50 }}
        aria-describedby={undefined}
      >
        <DialogTitle></DialogTitle>
        <AddMemberScreen
          selectedPart={selectedPart}
          onClose={onClose}
          onSubmit={onSubmit}
          state={state}
        />
      </DialogContent>
    </Dialog>
  );
}
